import Rule from "./rule";

class CustomerTagsRule extends Rule {
  type = "customer.tags";

  constructor(config = {}) {
    super(config);

    this.config.includes = this.normalizeTagConfig(this.config.includes);
    this.config.excludes = this.normalizeTagConfig(this.config.excludes);
  }

  evaluate(data) {
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    console.log('Config', this.config);
    let pass = true;

    let includesPass = this.config.includes.tags.length == 0 ? true : this.config.includes.tags[this.config.includes.comparator](tag => {
      console.log('Checking for included tag', tag, 'using comparator', this.config.includes.comparator);
      // @ts-ignore
      return window.MP.Data.customer.tags.includes(tag);
    });
    console.log("Pass on includes", includesPass);

    let excludesPass = this.config.excludes.tags.length == 0 ? true : !this.config.excludes.tags[this.config.excludes.comparator](tag => {
      console.log('Checking for excluded tag', tag, 'using comparator', this.config.excludes.comparator);
      // @ts-ignore
      return window.MP.Data.customer.tags.includes(tag);
    });
    console.log("Pass on excludes", excludesPass);

    pass = pass && includesPass && excludesPass;

    this.addLog(pass, "Tag config matches", pass ? "Tag config matches" : "Tag config does not match");
    
    console.log('Pass?', pass);
    console.groupEnd();
    return pass;
  }

  explain() {
    const joiner = (comp) => comp === "every" ? " and " : " or ";

    const parts = [];
    if (this.config.includes.tags.length)
      parts.push(`includes ${this.config.includes.tags.map(tag => MP.Logger.tag(tag)).join(joiner(this.config.includes.comparator))}`);
    if (this.config.excludes.tags.length)
      parts.push(`excludes ${this.config.excludes.tags.map(tag => MP.Logger.tag(tag)).join(joiner(this.config.excludes.comparator))}`);
    
    return `Customer tags ${parts.join(" and ")}`;
  }

  normalizeTagConfig(config = {}) {
    return {
      tags: [],
      comparator: "every",
      ...config
    };
  }

}

export default CustomerTagsRule;